const SAAS_KEYS = new Set([
  "saas_hero",
  "feature_story",
  "impact_stats",
  "stats_animated",
  "agency_scale",
  "bento_features",
  "review_wall",
  "trusted_by",
  "saas_features",
  "use_cases",
  "integrations_grid",
  "benefits",
  "product_demo",
  "how_it_works",
  "pricing_preview",
  "pricing_table",
  "pricing_comparison",
  "pricing_addons",
  "saas_testimonials",
  "saas_cta",
  "comparison_table",
  "comparison_breakdown",
  "schema_markup",
]);

export function isSaasSection(sectionKey: string) {
  return SAAS_KEYS.has(sectionKey);
}
